__turbopack_context__.v({
  "card_outer": "styles-module-scss-module__BqcTmG__card_outer",
  "container": "styles-module-scss-module__BqcTmG__container",
  "language_sort": "styles-module-scss-module__BqcTmG__language_sort",
  "license_checkboxes": "styles-module-scss-module__BqcTmG__license_checkboxes",
  "license_filter": "styles-module-scss-module__BqcTmG__license_filter",
  "search": "styles-module-scss-module__BqcTmG__search",
  "search_bar": "styles-module-scss-module__BqcTmG__search_bar",
  "search_bar_simple": "styles-module-scss-module__BqcTmG__search_bar_simple",
  "zero_state": "styles-module-scss-module__BqcTmG__zero_state",
});
